import { useCallback, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useNetInfo } from '@react-native-community/netinfo';

import { getModalVisible } from 'store/user/selectors';

import { reloadCurrentPage } from 'utils/NavigationService';
import usePrevious from 'utils/hooks/usePrevious';

type ReturnType = {
    tryAgain: () => void;
};

const useInternetGetBack = (dontReloadPage: boolean = false): ReturnType => {
    const { isConnected } = useNetInfo();
    const modalVisible = useSelector(getModalVisible);

    const prevIsConnected = usePrevious<boolean | null>(
        isConnected,
        isConnected,
    );

    useEffect(() => {
        if (
            prevIsConnected === false &&
            isConnected &&
            !dontReloadPage &&
            !modalVisible
        ) {
            reloadCurrentPage();
        }
    }, [prevIsConnected, isConnected, dontReloadPage, modalVisible]);

    const tryAgain = useCallback(() => {
        if (isConnected && !dontReloadPage && !modalVisible) {
            reloadCurrentPage();
        }
    }, [isConnected, dontReloadPage, modalVisible]);

    return {
        tryAgain,
    };
};

export default useInternetGetBack;
